import apiClient from './client';

export interface Material {
  id: string;
  name: string;
  category: string;
  vendor: string;
  inStock: number;
  reorderPoint: number;
  unitPrice: number;
  status: 'In Stock' | 'Low Stock' | 'Out of Stock';
}

export interface MaterialStats {
  totalItems: number;
  lowStock: number;
  totalVendors: number;
  totalValue: number;
}

export const getMaterials = async (params?: {
  search?: string;
  category?: string;
}): Promise<Material[]> => {
  const response = await apiClient.get('/materials', { params });
  return response.data.data;
};

export const getMaterialStats = async (): Promise<MaterialStats> => {
  const response = await apiClient.get('/materials/stats');
  return response.data.data;
};

export const createMaterial = async (materialData: Record<string, unknown>): Promise<Record<string, unknown>> => {
  const response = await apiClient.post('/materials', materialData);
  return response.data.data;
};

export const updateMaterial = async (id: string, materialData: Record<string, unknown>): Promise<void> => {
  await apiClient.put(`/materials/${id}`, materialData);
};

export const deleteMaterial = async (id: string): Promise<void> => {
  await apiClient.delete(`/materials/${id}`);
};
